import {
    SOCIETY_WINGS_LIST,
    SOCIETY_CREATE_WINGS,
    SOCIETY_EDIT_WINGS,
    SOCIETY_DELETE_WINGS,
    SOCIETY_FLATS_LIST,
    SOCIETY_CREATE_FLATS,
    SOCIETY_EDIT_FLATS,
    SOCIETY_DELETE_FLATS,
    SOCIETY_WINGS_DROPDOWN,
    SOCIETY_FLATS_DROPDOWN,
    SOCIETY_FLATS_WITH_OWNERSHIP,
    SOCIETY_BULK_UPLOAD_WINGS,
    SOCIETY_CLEAR_WINGS_BULK_UPLOAD_STATE,
    SOCIETY_BULK_UPLOAD_FLATS,
    SOCIETY_CLEAR_FLATS_BULK_UPLOAD_STATE,
} from '../index.types';


export function getWingsList(data) {
    return {
        type: SOCIETY_WINGS_LIST,
        data
    }
}

export function createWing(data) {
    return {
        type: SOCIETY_CREATE_WINGS,
        data
    }
}

export function editWing(data) {
    return {
        type: SOCIETY_EDIT_WINGS,
        data
    }
}

export function deleteWing(data) {
    return {
        type: SOCIETY_DELETE_WINGS,
        data
    }
}

export function getFlatsList(data) {
    return {
        type: SOCIETY_FLATS_LIST,
        data
    }
}

export function createFlat(data) {
    return {
        type: SOCIETY_CREATE_FLATS,
        data
    }
}

export function editFlat(data) {
    return {
        type: SOCIETY_EDIT_FLATS,
        data
    }
}

export function deleteFlat(data) {
    return {
        type: SOCIETY_DELETE_FLATS,
        data
    }
}

export function getWingsDropdown(data) {
    return {
        type: SOCIETY_WINGS_DROPDOWN,
        data
    }
}

export function getFlatsDropdown(data) {
    return {
        type: SOCIETY_FLATS_DROPDOWN,
        data
    }
}

export function getFlatsWithOwnership(data) {
    return {
        type: SOCIETY_FLATS_WITH_OWNERSHIP,
        data
    }
}

export const bulkUploadWings = (data) => ({ type: SOCIETY_BULK_UPLOAD_WINGS, data });
export const clearWingsBulkUploadState = () => ({ type: SOCIETY_CLEAR_WINGS_BULK_UPLOAD_STATE });

export const bulkUploadFlats = (data) => ({ type: SOCIETY_BULK_UPLOAD_FLATS, data });
export const clearFlatsBulkUploadState = () => ({ type: SOCIETY_CLEAR_FLATS_BULK_UPLOAD_STATE });
